import { render, staticRenderFns } from "./adesoes.vue?vue&type=template&id=15e974a0"
import script from "./adesoes.vue?vue&type=script&lang=js"
export * from "./adesoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports